import  {useState, useEffect} from 'react'
import { collection,  onSnapshot, query } from 'firebase/firestore';
 
import {  auth, db,} from '../firebase';

function useGetFavorites(id) { 
    
        const [user, setuser] = useState(null)
        useEffect(() => {
          if(id === undefined || id === null){
            return
          }
            const q = query(collection(db, "app_users", id, "likes"))
            onSnapshot(q, (querySnapshot) => {        
             const data =[]
             querySnapshot.forEach((doc) => {
                 const asd = {
                   ...doc.data(),
                   id: doc.id
                 }
                data.push(asd)      
               })
               
               setuser(data)
              });
        }, [auth.currentUser])
      return user
    }

export default useGetFavorites